import {get, post} from "../../../DAL/data-provider";
import {IResponse} from "../../../interfaces/common-interfaces";

export const RVP_SESSION_STORAGE_KEY = 'recently-viewed-products';
const RVP_URL = '/api/Account/RecentlyViewedProducts/';
const GA_EVENTS_TITLE = 'Recently Viewed Products';

export const removeRVPStorageItem = () => {
    if(!window.sessionStorage) return;
    window.sessionStorage.removeItem(RVP_SESSION_STORAGE_KEY);
};

export const rvpSetNullToStorage = () => {
    if(!window.sessionStorage) return;
    window.sessionStorage.setItem(RVP_SESSION_STORAGE_KEY, JSON.stringify(null));
};

/**
 * get products from database
 * @param {number} top
 * @param {string} command
 * @param {number} skuid
 * @return {Array.<object>}
 */
//Edited by Raz Liveyatan, 26.01.2021, https://wavesaudio.atlassian.net/browse/DSWEB-1003 (changed number of top items to 5)
export const getRVP = async (top = 0) => {
    return get(`${RVP_URL}get-recently-viewed-products?top=${top}`);
}

//Edited by Raz Liveyatan, 26.01.2021, https://wavesaudio.atlassian.net/browse/DSWEB-1003
export const removeRVP = async (skuid = -1) :Promise<IResponse|null>=> {

    const RvpRemoveDataUrl = 'remove-recently-viewed-product';
    const rvpVM = {
        SkuID:skuid
    }
    try{
        return await post(`${RVP_URL}${RvpRemoveDataUrl}`,rvpVM);
    }
    catch(ex){}

    return null;
}

//Edited by Raz Liveyatan, 26.01.2021, https://wavesaudio.atlassian.net/browse/DSWEB-1003
export const clearRVP = async () => {

    const RvpClearUrl = 'clear-recently-viewed-products';
    const SKUNumber = 0;
    try{
        return await post(`${RVP_URL}${RvpClearUrl}`,SKUNumber);
    }
    catch(ex){}

    return null;
}

/**
 * save products to session storage
 * @param {Array.<object>} products
 */
export const saveToStorage = (products:any) => {

    if(!window.sessionStorage) return;

    window.sessionStorage.setItem(RVP_SESSION_STORAGE_KEY, JSON.stringify(products));
};

/**
 * get products from session storage
 * @return {Array.<object>} products
 */
export const getFromStorage = () => {

    if(!window.sessionStorage) return [];

    let products = [];

    try{
        products = JSON.parse(window.sessionStorage.getItem(RVP_SESSION_STORAGE_KEY) as string);
    }
    catch(ex) {}

    return products;
};

/**
 * decode URL that is created in dot.net
 * @param {String} url
 * @return {string}
 */
export const decodeURL = (url:string) =>{
    return decodeURIComponent(url.replace(/\+/g, '%20'));
}

/**
 * function gets a product and return normalize it to required pattern
 * */
export const normalizeProduct =(product:any) => {

    if(!product) return product;

    // boolean properties normalizations
    product.title = GA_EVENTS_TITLE;
    product.skuEnabled = product.skuEnabled ? product.skuEnabled : false;
    product.isPreorder = product.isPreorder ? product.isPreorder : false;
    product.isProductOptions = product.isProductOptions ? product.isProductOptions : false;
    product.isVariantsPriceSame = product.isVariantsPriceSame ? product.isVariantsPriceSame : false;

    // properties with inner HTML - normalizations
    product.note = product.note ? decodeURL(product.note) : '';
    product.documentPageDescription = product.documentPageDescription ? decodeURL(product.documentPageDescription) : '';

    // computed properties
    product.withCouponEnabled = product.couponCampaignID > 0;
    product.isProductVisible = product.skuid > 0 && product.skuEnabled;
    product.isSamePrice = product.sku_MSRP === product.skuPrice;
    product.minPrice = !!product.note ? 'fake' : (product.couponPrice > 0 ? Math.min(product.skuPrice, product.couponPrice) : product.skuPrice);
    product.maxPrice = product.couponPrice > 0 ? Math.max(product.skuPrice, product.couponPrice) : product.skuPrice;

    // https://wavesaudio.atlassian.net/browse/DSWEB-1267
    // Edited by Raz Liveyatan, 07.06.2021
    product.expectedShipping = product.expectedShipping !== '' ? product.expectedShipping : null;

    return product;
};

